import ManageUsers from './components/ManageUsers';
import { bindActionCreators } from 'redux';
import values from 'lodash/values';
import {connect} from 'react-redux';

import { loadUsersForAgency,updateUser } from '../../shared/redux/entities/actions'

import {
  getActiveAgencyUser
} from '../../shared/redux/selectors';

function mapStateToProps(state){

  const activeAgencyId = getActiveAgencyUser(state).agencyId;

  return {
    activeAgencyId:activeAgencyId,
    users:values(state.entities.users).filter((u) => u.agencyId === activeAgencyId)
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ loadUsersForAgency,updateUser },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(ManageUsers);



// WEBPACK FOOTER //
// ./src/routes/ManageUsers/index.js